import { IActivityHistoryDiagnostic } from "../../model";

export const hasValidDiagnostic = (diagnostic: IActivityHistoryDiagnostic) => {
  return (
    diagnostic !== null &&
    diagnostic !== undefined &&
    typeof diagnostic.codi === "string" &&
    (typeof diagnostic.cataleg === "string" || diagnostic.cataleg === null) &&
    typeof diagnostic.descripcio === "string"
  );
};

// Comprueba las propiedades de un diagnóstico
export const hasValidDiagnostics = (diagnostics: IActivityHistoryDiagnostic[]) => {
  if (diagnostics === null || diagnostics === undefined) {
    return true;
  }

  return Array.isArray(diagnostics) && diagnostics.every(hasValidDiagnostic);
};
